module.exports = __webpack_public_path__ + "img/frame (247).d851320a.jpg";